module.exports = __webpack_public_path__ + "img/18.2a2e71be.png";